// extracted by mini-css-extract-plugin
module.exports = {"Board":"Board_Board__2eUuJ","boardItem":"Board_boardItem__3Jvhx","text":"Board_text__ux6mu","addNewlist":"Board_addNewlist__3HSHd","addButton":"Board_addButton__1Y3oM"};